import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { licenseTrackerEnvironment } from '../license-tracker-environment';
import { churnDataSchema } from '../schemas/churn-data.schema';

/**
 * Gets CoPilot Churn Data
 * @param productId The Product ID of the product you are requesting data for
 * @param startDate The start time of the request
 * @param dateGroupingType 1 for Monthly, 2 for Quarterly, 3 for Annually
 * @param partnerId ID of the partner
 * @param groupByAccountRep Whether to group by account rep
 * @param numberOfGroups The number of groups to return
 * @returns CoPilot Churn Data
 */

export function getAccountsProductIdChurnReport(
  this: unknown,
  productId: number,
  startDate: Date,
  dateGroupingType: '0' | '1' | '2',
  partnerId: string,
  groupByAccountRep: boolean,
  numberOfGroups: number
) {
  const queryString = [
    `startDate=${startDate.toISOString()}`,
    `dateGroupingType=${dateGroupingType}`,
    `partnerId=${partnerId}`,
    `groupByAccountRep=${groupByAccountRep}`,
    `numberOfGroups=${numberOfGroups}`,
  ].join('&');

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${licenseTrackerEnvironment
          .resolve(this)
          .accountsProductIdChurnReport(productId.toString())}?${queryString}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        groupByAccountRep: z.boolean(),
        months: z.array(churnDataSchema).optional(),
        quarters: z.array(churnDataSchema).optional(),
        years: z.array(churnDataSchema).optional(),
        reps: z.record(z.string(), z.array(churnDataSchema)).optional(),
      })
    )
  );
}
